module.exports = __webpack_public_path__ + "img/sfq2.24ec5c69.png";